// Phase T2.0A Prompt 4 — Home Featured API client.
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

function api() {
  const token = localStorage.getItem('tl_session_token');
  return axios.create({
    baseURL: `${BASE}/api`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export const homeFeaturedAPI = {
  list: () => api().get('/home/featured'),
};
